import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed';
import Companies from './containers/Companies';
import Users from './containers/Users';

const Administration = {
  Helmet: lazy(() => import('./components/Helmet')),

  Users,
  Companies,

  BatchLayout: lazy(() => import('./containers/Batch/components/BatchLayout')),

  JobList: lazy(() => import('./containers/Batch/components/JobList')),
  BatchK8s: lazyNamed(() => import('./containers/BatchK8s'), 'BatchK8s'),
  JobExecutionLog: lazy(() => import('./containers/Batch/components/JobExecutionLog')),

  Mail: {
    Layout: lazy(() => import('./containers/Mail/components/MailLayout')),
    Console: lazy(() => import('./containers/Mail/containers/Console')),
    SalesPromotions: lazy(() => import('./containers/Mail/containers/SalesPromotions')),
  },

  Localization: lazyNamed(() => import('./containers/Localization'), 'Localization'),

  Permalead: lazy(() => import('./containers/Permalead')),

  XandrCredentials: lazy(() => import('./containers/XandrCredentials')),
  XandrSegments: lazyNamed(() => import('./containers/XandrSegments'), 'XandrSegments'),
};

export default Administration;
